import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeliveryOptionsService {
  private deliveryOptionSubject = new BehaviorSubject<any>(null);
  public deliveryOption$: Observable<any> = this.deliveryOptionSubject.asObservable();

  private optionListSubject = new BehaviorSubject<any[]>([]);
  public optionList$: Observable<any[]> = this.optionListSubject.asObservable();

  constructor() {
    // Initialize from localStorage if available
    this.loadFromLocalStorage();
  }

  // Set the selected delivery option
  setDeliveryOption(option: any): void {
    this.deliveryOptionSubject.next(option);
    this.saveToLocalStorage(option);
  }

  // Get current delivery option
  getDeliveryOption(): any {
    return this.deliveryOptionSubject.value;
  }

  // Set the option list
  setOptionList(options: any[]): void {
    this.optionListSubject.next(options);
  }

  // Get current option list
  getOptionList(): any[] {
    return this.optionListSubject.value;
  }

  // Save to localStorage
  private saveToLocalStorage(option: any): void {
    if (option) {
      const storedDetail = localStorage.getItem('payOutDetail');
      if (storedDetail) {
        try {
          const payOutDetail = JSON.parse(storedDetail);
          payOutDetail.deliveryMode = option.deliveryType;
          payOutDetail.deliveryFee = option.deliveryAmount || 0;
          payOutDetail.weight = option.weight;
          payOutDetail.volume = option.volume;
          localStorage.setItem('payOutDetail', JSON.stringify(payOutDetail));
        } catch (e) {
          console.error('Error saving delivery option to localStorage:', e);
        }
      }
    }
  }

  // Load from localStorage
  private loadFromLocalStorage(): void {
    const storedDetail = localStorage.getItem('payOutDetail');
    if (storedDetail) {
      try {
        const payOutDetail = JSON.parse(storedDetail);
        if (payOutDetail.deliveryMode) {
          // Create a minimal option object from stored data
          const option = {
            deliveryType: payOutDetail.deliveryMode,
            deliveryAmount: payOutDetail.deliveryFee || 0,
            weight: payOutDetail.weight,
            volume: payOutDetail.volume
          };
          this.deliveryOptionSubject.next(option);
        }
      } catch (e) {
        console.error('Error loading delivery option from localStorage:', e);
      }
    }
  }

  // Update payOutDetail total when delivery option changes
  updatePayOutDetailTotal(subtotal: number): void {
    const option = this.getDeliveryOption();
    if (option && option.deliveryAmount !== undefined) {
      const storedDetail = localStorage.getItem('payOutDetail');
      if (storedDetail) {
        try {
          const payOutDetail = JSON.parse(storedDetail);
          payOutDetail.subTotal = subtotal;
          payOutDetail.deliveryFee = option.deliveryAmount || 0;
          payOutDetail.totalAmount = subtotal + (option.deliveryAmount || 0);
          localStorage.setItem('payOutDetail', JSON.stringify(payOutDetail));
        } catch (e) {
          console.error('Error updating payOutDetail total:', e);
        }
      }
    }
  }
}
